import React, { Component } from 'react';
import { I18n } from 'react-redux-i18n';
import { connect } from 'react-redux';
import moment from 'moment-timezone';
import { history } from '../routers/AppRouter';
import Table from '../components/table/table';
import TableRegisterButton from '../components/table/registerButton';
import ROUTES from '../data/routes';
import { getAllProductTelecom, updateProductTelecom } from '../app/store/actions/productTelecom';
import ModalComponent from '../components/modal';

class ProductTelecomPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      limit: 10,
      page: 1,
      search: '',
      orderBy: 'DESC',
      field: 'createdAt',
      listProductTelecom: [],
      totalRecord: 0,
      showModal: false,
      showCancel: false,
      titleModal: '',
      titleModalBody: '',
      selectedLine: {},
    };

    this.tableHeader = [
      { key: 'productCode', value: I18n.t('productCode') },
      { key: 'productDescription', value: I18n.t('description') },
      { key: 'typeSolutionDescription', value: I18n.t('typeSolution') },
      { key: 'cableCategoryDescription', value: I18n.t('category') },
      { key: 'typeCoatingDescription', value: I18n.t('typeCoating') },
      { key: 'createdAt', value: I18n.t('createdIn') },
      { key: 'updatedAt', value: I18n.t('changedIn') },
      { key: 'status', value: I18n.t('status') },
      { key: 'action', value: I18n.t('action') },
    ];
  }

  componentDidMount() {
    this.getAllProductTelecom();
  }

  updateProductTelecomStatus = async (parameters = {}) => {
    try {
      await this.props.updateProductTelecom({ ...parameters })

      await this.getAllProductTelecom();
    } catch (err) {

      const error = err.response && err.response.data && err.response.data.error
      if (error && error.message) {
        const messageError = (error.code && error.details) ?
          `${error.code} - ${error.details} | ${error.message}`
          : error.message;

        this.setState({
          showModal: true,
          showCancel: false,
          titleModal: I18n.t('Error'),
          titleModalBody: messageError
        })
      } else {
        this.setState({
          showModal: true,
          showCancel: false,
          titleModal: I18n.t('Error'),
          titleModalBody: I18n.t('errorOcurred')
        })
      }
    }
  }

  adjustData = async (count = 0, rows = []) => {
    const listProductTelecom = rows.map((element, index) => ({
      key: index,
      id: element.id,
      productCode: element.product.code,
      productDescription: element.product.description,
      typeSolutionDescription: element.typeSolution && element.typeSolution.description,
      cableCategoryDescription: element.cableCategory && element.cableCategory.description,
      typeCoatingDescription: element.typeCoating && element.typeCoating.description,
      createdAt: moment(element.createdAt).format('L LT'),
      updatedAt: moment(element.updatedAt).format('L LT'),
      status: (
        <div className="row margin-left-0">
          <button
            type="button"
            className={`btn btn-${element.status ? 'warning' : 'dark'} promotion-btn-${element.status ? 'warning' : 'active'}`}
            onClick={() => this.updateProductTelecomStatus({
              id: element.id,
              status: !element.status,
              productId: element.productId,
              typeSolutionId: element.typeSolutionId,
              typeCoatingId: element.typeCoatingId, 
              cableCategoryId: element.cableCategoryId, 
              formula: element.formula,
            })}
          >
            {(element.status)
              ? I18n.t('disable')
              : I18n.t('active')
            }
          </button>
        </div>
      ),
      action: (
        <div className="btn-group" role="group" aria-label="Button group with nested dropdown">
          <div className="btn-group" role="group">
            <button
              id="btnGroupDrop1"
              type="button"
              className="btn btn-secondary dropdown-toggle"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              {I18n.t('action')}
            </button>
            <div className="dropdown-menu" aria-labelledby="btnGroupDrop1">
              <button
                type="button"
                className="dropdown-item dropdown-table"
                onClick={() => {
                  history.push({
                    pathname: ROUTES.FORM,
                    screenComming: 'productTelecom',
                    selectedProductTelecom: element,
                  });
                }
                }
              >
                {I18n.t('edit')}
              </button>
            </div>
          </div>
        </div>
      ),
    }));

    this.setState({
      totalRecord: count,
      listProductTelecom,
    });
  }

  getAllProductTelecom = async () => {
    const {
      search, page, limit, orderBy = '', field = '',
    } = this.state;
    const skip = (page - 1) * limit;

    try {
      const { count = 0, rows = [] } = await this.props.getAllProductTelecom(
        limit, skip, search, orderBy, field,
      );

      await this.adjustData(count, rows);
    } catch (err) {
      const error = err.response && err.response.data && err.response.data.error;
      if (error && error.message) {
        const messageError = (error.code && error.details)
          ? `${error.code} - ${error.details} | ${error.message}`
          : error.message;

        this.setState({
          showModal: true,
          showCancel: false,
          titleModal: I18n.t('Error'),
          titleModalBody: messageError,
        });
      } else {
        this.setState({
          showModal: true,
          showCancel: false,
          titleModal: I18n.t('Error'),
          titleModalBody: I18n.t('erroFetch'),
        });
      }
    }
  }

  sortTable = async (field, orderBy) => {
    await this.setState({ orderBy, field });
    await this.getAllProductTelecom();
  }

  searchTable = async (search = '', page = 1) => {
    await this.setState({ search, page });
    await this.getAllProductTelecom();
  }

  confirmModal = async () => {
    this.setState({ showModal: false });
  }

  tableButtons = () => (
    <React.Fragment>
      <TableRegisterButton route={{ pathname: ROUTES.FORM, screenComming: 'productTelecom' }} />
    </React.Fragment>
  )

  render() {
    const {
      limit, page, listProductTelecom, totalRecord, titleModal, titleModalBody, showModal, showCancel,
    } = this.state;

    return (
      <div className="main-div-tables">
        <ModalComponent
          title={titleModal}
          showCancel={showCancel}
          body={titleModalBody}
          visible={showModal}
          closeModal={() => this.setState({ showModal: false })}
          titleOkButtoon={I18n.t('ok')}
          size={{ width: '400px', height: '250px' }}
          showButtons
          confirmModal={this.confirmModal}
        />
        <Table
          title={I18n.t('products')}
          buttons={this.tableButtons()}
          header={this.tableHeader}
          lines={listProductTelecom}
          page={page}
          perPage={limit}
          count={totalRecord || 0}
          searchItems={this.searchTable}
          showItemsCount
          sortTable={this.sortTable}
        />
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  getAllProductTelecom: (limit, skip, search, orderBy, field) => dispatch(getAllProductTelecom(limit, skip, search, orderBy, field)),
  updateProductTelecom: (updProductTelecom) => dispatch(updateProductTelecom(updProductTelecom)),
});

const mapStateToProps = () => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(ProductTelecomPage);
